module.exports = __webpack_public_path__ + "static/3_section_bg-97a0878d7bf5bcfc7935df8c77009be1.svg";